export default __webpack_public_path__ + "static/media/walnessCenter.c8a87193.png";